// extracted by mini-css-extract-plugin
export default {"animationContainer":"styles_animationContainer__ryFiv"};